<template>
  <div class="sticky-pane" v-html="value"></div>
</template>
<script>
import GenericReportType from './GenericReportType';

export default {
  name: 'ReportHtml',
  mixins: [GenericReportType],
  computed: {
    value() {
      const value = this.firstData.value || '';
      if (this.report.visual === 'header') {
        return `<h1 class='report-vertical-aligned'>${value}</h1>`;
      }
      return value;
    },
  },
};
</script>
